import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import icon from './websiteIcon.jpg';
import backgroundVideo from './brahmand.mp4'; 

const { Title } = Typography;

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await fetch('https://be-lb.chitragupta.co/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
        credentials: 'include', // Ensure cookies (refreshToken) are set
      });

      if (!response.ok) throw new Error('Username or Password is incorrect !');

      const data = await response.json();
      message.success('Login successful!');
      onLogin(data.accessToken); // Store accessToken, not token
    } catch (err) {
      message.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'relative', height: '100vh', overflow: 'hidden', background: videoLoaded ? 'transparent' : '#000' }}>
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        onLoadedData={() => setVideoLoaded(true)} // Set video as loaded
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
          opacity: videoLoaded ? 1 : 0,  // Hide video initially
          transition: 'opacity 0.5s ease-in-out', // Smooth fade-in effect
        }}
      >
        <source src={backgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Login Card */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Card
        style={{
          width: 350,
          padding: '30px',
          textAlign: 'center',
          background: 'rgba(180, 232, 250, 0.6)', // Transparent white
          borderRadius: '12px',
          backdropFilter: 'blur(8px)', // Frosted effect
          border: '1px solid rgba(255, 255, 255, 0.5)',
          boxShadow: '0 4px 20px rgba(222, 221, 221, 0.46)',

          // Patterned Background
          backgroundImage: `url('https://www.transparenttextures.com/patterns/cubes.png')`, 
          backgroundSize: 'auto',
        }}
      >
          <img src={icon} alt="Chitragupta" style={{ width: 60, height: 60, marginBottom: 5 }} />
          <Title level={4} style={{ color: '#323f51', fontWeight: 'bold' }}>
            Chitragupta Infraction Verification Tool
          </Title>

          <Form layout="vertical" onFinish={handleLogin}>
            <Form.Item name="username" rules={[{ required: true, message: 'Please enter your username' }]}>
              <Input prefix={<UserOutlined />} placeholder="Username" size="large" />
            </Form.Item>

            <Form.Item name="password" rules={[{ required: true, message: 'Please enter your password' }]}>
              <Input.Password prefix={<LockOutlined />} placeholder="Password" size="large" />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block size="large" loading={loading} style={{ backgroundColor: '#fe5c4c', border: 'none' }}>
                Login
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Login;
